import { Navbar as FbNavbar, NavbarBrand } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { RiUserSettingsLine } from 'react-icons/ri';
import { useNavigate } from 'react-router';
import UserProfileMenu from 'src/components/admin/navigation/userProfileMenu';
import { useSiteConfig } from 'src/contexts/SiteGuardContext';
import { routePaths } from 'utils/constants';
import AppImage from 'components/image/AppImage';

type TopNavbarProps = {
   className?: string;
   darkMode?: boolean;
};

const AdminTopNavbar: React.FC<TopNavbarProps> = () => {
   const navigate = useNavigate();
   const [t] = useTranslation();
   const { siteConfig } = useSiteConfig();
   const displayName = siteConfig?.displayName || 'Nonprofit Trips';
   const sitePrimaryLogo = siteConfig?.visualBranding?.primaryLightLogo;

   return (
      <FbNavbar
         theme={{ root: { inner: { base: 'w-full' } } }}
         fluid
         rounded={false}
         className="flex items-center px-3.75 md:px-7.5 sticky top-0 z-50 w-full bg-tertiary border-none max-h-[68px] h-[68px] shadow-[4px_4px_10px_0px_#00000033]"
      >
         <div className="flex items-center font-semibold text-white gap-x-4">
            <NavbarBrand href={routePaths.ADMIN.ORGANIZATION.INDEX} className="pl-1.75 md:pl-0 pr-2">
               <AppImage
                  alt={`${displayName} logo`}
                  className="h-12.5 sm:h-12.5 max-h-9.5"
                  src={sitePrimaryLogo}
               />
            </NavbarBrand>
            <div
               className="hidden md:flex items-center pl-6 border-l border-primaryInteract cursor-pointer"
               onClick={() => navigate(routePaths.ADMIN.ORGANIZATION.INDEX)}
            >
               <RiUserSettingsLine />
               <span className="text-white font-semibold ml-1.5">{t('navbar.admin')}</span>
            </div>
         </div>

         <div className="flex items-center">
            {/* User menus */}
            <UserProfileMenu darkMode={true} />
         </div>
      </FbNavbar>
   );
};

export default AdminTopNavbar;
